import { Injectable } from '@angular/core'
import { AppBasicService } from '@data/service/app-basic.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

import { HttpHeaders } from '@angular/common/http'

@Injectable()
export class UserService extends AppBasicService {
   getCurrent(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/pmp/users/current`, this.httpOptions).pipe(
         map((res: any) => {
            return this.dataSrv.mapUser(res, 'current')
         })
      )
   }

   getById(id: any): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/users/${id}`, this.httpOptions)
   }

   getCountries(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/regions/detail`, this.httpOptions)
   }

   getRegionsByCountryId(id: any): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/regions/detail/${id}`, this.httpOptions)
   }

   getSectors(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/sectors`, this.httpOptions)
   }

   getCompanyTypes(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/beneficiaries`, this.httpOptions)
   }

   getTechnologies(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/technologies`, this.httpOptions)
   }
}
